import { useEffect, useState } from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import { api } from '../services/api'

export default function TimeSeriesChart() {
  const [data, setData] = useState<Array<{
    date: string
    revenue: number
    conversions: number
  }>>([])
  const [days, setDays] = useState(7)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await api.getTimeSeriesData(days)
        setData(result)
      } catch (error) {
        console.error('Failed to fetch time series:', error)
      }
    }
    fetchData()
  }, [days])

  return (
    <div className="bg-slate-800 rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-white">📊 추세 분석</h2>
        <select
          value={days}
          onChange={(e) => setDays(Number(e.target.value))}
          className="bg-slate-700 text-white px-3 py-2 rounded-lg"
        >
          <option value={7}>7일</option>
          <option value={14}>14일</option>
          <option value={30}>30일</option>
        </select>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
          <XAxis dataKey="date" stroke="#9ca3af" />
          <YAxis stroke="#9ca3af" />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1e293b',
              border: '1px solid #334155',
              borderRadius: '8px',
            }}
            labelStyle={{ color: '#fff' }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="revenue"
            stroke="#22c55e"
            strokeWidth={2}
            name="매출"
            dot={{ r: 4 }}
          />
          <Line
            type="monotone"
            dataKey="conversions"
            stroke="#0ea5e9"
            strokeWidth={2}
            name="전환"
            dot={{ r: 4 }}
          />
          <Line
            type="monotone"
            dataKey="leads"
            stroke="#a855f7"
            strokeWidth={2}
            name="리드"
            dot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
